import ApiRequest from '@/plugins/axios'

export default {
  getList () {
    return ApiRequest.get('help').then((response) => response.data)
  }
}
